<div class="form-group">
    <label for="{{{o.id}}}">{{{o.label}}}</label>
    <select class="form-control" id="{{{o.id}}}" name="{{{o.name}}}" {[ if (o.multiple) { ]} multiple="multiple" {[ } ]}>{{o.options}}</select>
</div>
